import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import InspectionTypeContracts from './InspectionType'
import FormContracts from './FormSelection'
import StatusContracts from './Status'
import DurationContracts from './Duration'

function ContractsSettings() {
    return(
        <>
        <TextMediumSM content="Contracts" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        {/* <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <DurationContracts/>
         </div> */}
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <FormContracts/>
         </div>
         {/* <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <InspectionTypeContracts/>
         </div> */}
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusContracts/>
         </div>
        
       
         </div>
         </>
    )
}

export default ContractsSettings
